import {ManualLayout} from '../components/ManualLayout.tsx';
import {Outlet, createRootRoute, useRouterState} from '@tanstack/react-router';

const RootComponent: React.FC = () => {
  const pathname = useRouterState({select: state => state.location.pathname});

  // The /print view renders without the header/sidebar so the print dialog produces a clean PDF.
  if (pathname.endsWith('/print')) {
    return <Outlet />;
  }

  return (
    <ManualLayout>
      <Outlet />
    </ManualLayout>
  );
};

export const Route = createRootRoute({
  component: RootComponent,
});
